// resetAcquisitionCode.js
'use strict';
import { MERGE_ME_DATA, MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { replace } from '../action/navigationAction.js';

/**
 * Reset acquisition code
 * @kind action
 * @return {Promise} Action promise.
 */
const resetAcquisitionCode = () => async dispatch => {
  // Prevent loadUrlQueryUtm will auto redirect to redeem page again if redirectUrl including referral term.
  dispatch({
    type: MERGE_ME_DATA,
    payload: {
      utm: {
        utm_term: undefined,
      },
    },
  });
  dispatch({
    type: MERGE_OPERATION_DATA,
    payload: {
      selectPath: ['acquisition'],
      data: {
        prepaid: {
          code: '',
        },
        referral: {
          code: '',
        },
        amount: null,
        errorI18nkey: null,
      },
    },
  });
  const url = new URL(location.href);
  if (url.searchParams.has('utm_term')) {
    url.searchParams.delete('utm_term');
    return dispatch(replace(`${url.pathname}${url.search}`));
  }
};

export default resetAcquisitionCode;
